import React, { Component } from 'react';
import classNames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';
import Field from '../Field/Field.jsx';

class Select extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};

		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		const { options, value, ...rest } = this.props;
		const { isOpen } = this.state;

		let activeOption = value
			? options.find(option => option.value === value)
			: {};

		return (
			<div className="select">
				<Field
					type="text"
					{...rest}
					value={activeOption.text}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
				/>
				{isOpen && this.renderOptions()}
				<div className="select__arrow" />
			</div>
		);
	}

	renderOptions() {
		const { options, value } = this.props;

		return (
			<div className="select__options">
				<ul
					className="select__options-container"
					ref={node => (this.optionsContainer = node)}
				>
					{options.map(option => {
						const optionClass = classNames('select__option', {
							'select__option--active': option.value === value
						});
						return (
							<li
								key={option.value}
								className={optionClass}
								onClick={() => this.handleClick(option.value)}
							>
								{option.text}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	handleFocus() {
		this.setState({ isOpen: true });
		setTimeout(
			() =>
				this.optionsContainer.classList.add(
					'select__options-container--visible'
				),
			300
		);
	}

	handleBlur(e) {
		setTimeout(() => this.setState({ isOpen: false }), 300);
	}

	handleClick(value) {
		const { name, onChange } = this.props;

		onChange(value, name);
	}

	handleClickOutside() {
		this.setState({ isOpen: false });
	}
}

export default enhanceWithClickOutside(Select);



// WEBPACK FOOTER //
// ./src/js/Ui/Select/Select.jsx